import { render, staticRenderFns } from "./ChildOrderTable.vue?vue&type=template&id=5a996822&scoped=true&"
import script from "./ChildOrderTable.vue?vue&type=script&lang=js&"
export * from "./ChildOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./ChildOrderTable.vue?vue&type=style&index=0&id=5a996822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a996822",
  null
  
)

export default component.exports